import { render, staticRenderFns } from "./OtherActivitiesOffered.vue?vue&type=template&id=1518e116&scoped=true"
import script from "./OtherActivitiesOffered.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherActivitiesOffered.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OtherActivitiesOffered.vue?vue&type=style&index=0&id=1518e116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518e116",
  null
  
)

export default component.exports